import { useAppSelector } from 'src/store/hooks';
import i18n from 'src/i18n';

export const useIsRTL = () => {
  const language = useAppSelector((state) => state.main.ui.language);

  return i18n.dir(language) === 'rtl';
};
